import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map, Observable, of, switchMap, take } from 'rxjs';
import { OidcLoginService } from '../services/oidc.login.service';

export const isAuth = (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Observable<boolean> => {
  const oidcLoginService = inject(OidcLoginService);
  const oidcSecurityService = inject(OidcSecurityService);
  const isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  // SSR: на сервере браузерного OIDC-состояния нет, поэтому не блокируем рендер —
  // окончательную проверку делает клиент после гидрации.
  if (!isBrowser) {
    return of(true);
  }

  // 1) Дожидаемся единого стартового checkAuth() (OidcLoginService.authChecked$) —
  //    это убирает гонку: при клике на защищённый маршрут до завершения checkAuth()
  //    мы ждём его результат, а не хватаем ещё не готовый false.
  // 2) Решение принимаем по ЖИВОМУ isAuthenticated$ — чтобы реагировать на выход/
  //    протухание сессии в рамках одной вкладки (без перезагрузки), а не на закэш.
  return oidcLoginService.authChecked$.pipe(
    take(1),
    switchMap(() => oidcSecurityService.isAuthenticated$.pipe(take(1))),
    map(({ isAuthenticated }) => {
      if (isAuthenticated) {
        return true;
      }

      // Не уводим на /home — сразу открываем OIDC-вход и возвращаемся на
      // запрошенный маршрут (state.url) после авторизации.
      oidcLoginService.login(undefined, state.url);
      return false;
    }),
  );
};
